export { default as ColorfulButton } from './components/colorful-button';
export { default as ColorfulInput } from './components/colorful-input';
const bizCssPrefix = 'bizpack';
export { bizCssPrefix };
